<template>
    <v-row class="d-flex align-center">
        <v-col cols="4">
            <v-text-field
                :value="templateName"
                :label="$t('Template name')"
                outlined
                :disabled="!canEditTemplate"
                :error-messages="errors.template_name"
                @input="$emit('updateTemplateName', $event)"
            />
        </v-col>
        <v-col cols="8">
            <v-checkbox
                :input-value="isPublic"
                color="grey"
                hide-details
                :label="$t('Public')"
                :disabled="isPublicDisabled"
                :error-messages="errors.is_public"
                class="pt-0 mt-1 body-2"
                @change="$emit('updateIsPublic', $event)"
            />
        </v-col>
    </v-row>
</template>

<script>
import ComboboxDropdown from "../../../components/ComboboxDropdown";

export default {
    name: "EditTemplateOptions",
    components: {
        ComboboxDropdown
    },
    props: {
        templateName: {
            type: String,
            default: null
        },
        isPublic: {
            type: Boolean,
            default: null
        },
        isPublicDisabled: {
            type: Boolean,
            required: true
        },
        errors: {
            type: [Object, Error],
            required: true
        },
        canEditTemplate: {
            type: Boolean,
            required: true
        }
    },
    setup() {
        return {


        }
    }
}
</script>

<style scoped>

</style>